export default "__VITE_ASSET__Dnkvl9PM__"